import { Link } from "react-router-dom";
import { MapPinOff, Phone } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PHONE, PHONE_HREF } from "@/data/site";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-brand-subtle min-h-[70vh] flex items-center">
      <Seo title="Page Not Found | Central Air Depot" description="The page you're looking for doesn't exist. Explore Central Air Depot's AC services, maintenance plans and South Florida service areas." noindex />
      <div className="max-w-2xl mx-auto px-4 py-16 sm:py-24 text-center">
        <MapPinOff className="w-16 h-16 text-brand mx-auto" />
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mt-6">Error 404</p>
        <h1 data-testid="not-found-headline" className="text-4xl sm:text-5xl tracking-tighter leading-none font-black text-brand-ink mt-3">
          This page took the day off.
        </h1>
        <p className="text-zinc-600 mt-5 leading-relaxed max-w-lg mx-auto">
          The address you entered doesn't exist. Head back home, browse our services, or give us a call — we're happy to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/" data-testid="not-found-home-link"
            className="bg-brand hover:bg-brand-dark text-white font-bold px-8 py-4 rounded-sm transition-colors duration-200">
            Back to Home
          </Link>
          <Link to="/services" data-testid="not-found-services-link"
            className="border-2 border-brand-ink text-brand-ink hover:bg-brand-ink hover:text-white font-bold px-8 py-4 rounded-sm transition-colors duration-200">
            View Services
          </Link>
          <a href={PHONE_HREF} data-testid="not-found-call-link"
            className="flex items-center justify-center gap-2 text-brand font-bold px-4 py-4">
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
        </div>
      </div>
    </div>
  );
}
